import { briefTextToHtml } from "@nlc/shared-types";
import { useMemo, useState } from "react";

import { Button } from "@/components/button";
import { TiptapEditor } from "@/components/ui/TiptapEditor";

import { briefTextFromDoc } from "../brief-text";

type BriefTextEditorProps = {
  onCancel: () => void;
  /** Called with the edited plain text, only when it changed. */
  onSave: (value: string) => void;
  placeholder?: string;
  value: string;
};

export function BriefTextEditor({
  onCancel,
  onSave,
  placeholder,
  value,
}: BriefTextEditorProps) {
  const [draft, setDraft] = useState(value);
  // `content`, not `value`: TiptapEditor re-applies `value` whenever the
  // editor is empty, which would undo clearing the field.
  const initialContent = useMemo(() => briefTextToHtml(value), [value]);

  const save = () => {
    if (draft !== value.trim()) onSave(draft);
    onCancel();
  };

  return (
    <div className="flex flex-col gap-3">
      <TiptapEditor
        autofocus="end"
        className="max-h-[500px] max-w-full @container"
        content={initialContent}
        onUpdate={({ editor }) => setDraft(briefTextFromDoc(editor.getJSON()))}
        placeholder={placeholder}
      />
      <div className="flex justify-end gap-2">
        <Button color="gray" onPress={onCancel} size="sm" variant="secondary">
          Cancel
        </Button>
        <Button onPress={save} size="sm" variant="primary">
          Save
        </Button>
      </div>
    </div>
  );
}
